import Base64 from 'crypto-js/enc-base64';
import Utf8 from 'crypto-js/enc-utf8'

export function base64(str) {
    let utf8str = Utf8.parse(str);
    return Base64.stringify(utf8str);
}

// Source: https://auth0.com/docs/api-auth/tutorials/authorization-code-grant-pkce
export function base64UrlEncode(str) {
    return base64(str)
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '');
}
